import moment from 'moment';
import {
  CellTooltipContent,
  CellTooltipWrapperHover,
  TableBodyCellColumn,
  TableBodyCellColumnCenter,
} from '../../constants/style/table.styled';
import { DATE_FORMAT, DATE_FORMAT_WITH_TIME, TIME_FORMAT } from '@packages/shared/constants';
import { Display } from '../../constants/style/common.styled';
import Tag from '../../components/lozenge/tags';
import {
  CommaFormatted,
  convertNumberWithCommas,
  handleOpenFile,
  setDashAsEmptyValue,
} from '@packages/shared/utils';
import clsx from 'clsx';
import { COLORS } from '../../constants/style/color';
import _ from 'lodash';
import ClickableTooltip from '../../components/tooltip/clickTooltip';
import { PopoverModelWrapper } from '../../components/modal/modal.styled';
import Heading from '../../components/typography';
import React, { useContext, useEffect, useRef, useState } from 'react';
import useDynamicTable from './hooks/useDynamicTable';
import DOMPurify from 'dompurify';
import Tooltip from '../../components/tooltip';
import { HoverTooltip } from '../../components/tooltip-portal';

export type TableSettingsConfig = {};

export const getTableCell = (cell: any, onDoubleClick?: any) => {
  // console.log('cell.column.id', cell.column.id, cell.column);

  if (cell.column.isDateField) return <DateField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isDateFieldWithTime)
    return <DateFieldWithTime cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isTimeField) return <TimeField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isBadgeField) return <BadgeField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isInjectedBadgeField)
    return <InjectBadgeField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isDefaultBadgeField)
    return <DefaultBadgeField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isCurrencyField)
    return <CurrencyField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isDateRangeField)
    return <DateRangeCell cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isPercentageField)
    return <PercentageField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isCoupleDateRangeField)
    return <CoupleDateRangeField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isMaskBehaviorField)
    return <EnableMaskedValueTooltipOnClick cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isCoupleField) return <CoupleField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isConditionalField)
    return <ConditionalField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isNumberField) return <NumberField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isModalField) return <ModalField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isConditionalDateField)
    return <CondtionalDateField cell={cell} onDoubleClick={onDoubleClick} />;
  if (cell.column.isHtmlFormattedField) {
    return <HtmlFormattedField cell={cell} onDoubleClick={onDoubleClick} />;
  }
  return <TableCell cell={cell} onDoubleClick={onDoubleClick} />;
};

const getMaskedValue = (value: string, format: 'partial' | 'full'): string => {
  // console.log('format', format);

  const getSplitValue = value.split('').length;
  if (format === 'partial') return `XXXXXXXX${value.slice(getSplitValue - 4, getSplitValue)}`;
  else if (format === 'full') return 'XXXXXXXXX';
  return value; // Fallback
  return value.slice(getSplitValue - 4, getSplitValue);
};

const ModalField = ({ cell, onDoubleClick }: any) => {
  const { handleShow, tableInfo } = useDynamicTable(); // Access handleShow from context
  const row = cell.row.original;
  const popoverInfo = cell.column.popoverInfo;
  const fields = cell.column.fields;
  const value = cell.value;
  const center = cell.column.center;
  const enableTag = cell.column.enableTag;

  const isExcluded =
    row[fields['excludeKey']] && fields['excludeValue']
      ? row[fields['excludeKey']] === fields['excludeValue']
      : false;

  const handleClick = (event: any) => {
    if (handleShow) {
      handleShow(row[fields['id']] ? row[fields['id']] : row, event, popoverInfo);
    }
  };
  // const handleClick = (event: any) => {
  //   if (handleShow) {
  //     handleShow(row[fields['id']] ? row[fields['id']] : row, event, popoverInfo);
  //   }
  // };

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {isExcluded ? (
        <Heading variant='body-s' title={value || '-'} />
      ) : (
        <PopoverModelWrapper className='pop-overs'>
          {enableTag ? (
            <span
              onClick={handleClick}
              style={{
                cursor: 'pointer',
                textDecoration: 'none',
                color: 'black',
                borderWidth: '1px',
                padding: '2px 3px',
                fontSize: '12px',
                backgroundColor: 'rgb(243 243 243/ 1)',
                borderRadius: '4px',
              }}>
              {value || '-'}
            </span>
          ) : (
            <span
              onClick={handleClick}
              style={{ cursor: 'pointer' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
                e.currentTarget.style.color = 'blue';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'none';
                e.currentTarget.style.color = 'black';
              }}>
              {value || '-'}
            </span>
          )}
        </PopoverModelWrapper>
      )}
      {/* {enableTag ? (
        <span
          onClick={handleClick}
          style={{
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'black',
            borderWidth: '1px',
            padding: '2px 3px',
            fontSize: '12px',
            backgroundColor: 'rgb(243 243 243/ 1)',
            borderRadius: '4px',
          }}>
          {value || '-'}
        </span>
      ) : (
        <span
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
          onMouseEnter={(e) => (
            (e.currentTarget.style.textDecoration = 'underline'),
            (e.currentTarget.style.color = 'blue')
          )}
          onMouseLeave={(e) => (
            (e.currentTarget.style.textDecoration = 'none'), (e.currentTarget.style.color = 'black')
          )}>
          {value || '-'}
        </span>
      )} */}
    </td>
  );
};

const EnableMaskedValueTooltipOnClick = ({ cell, onDoubleClick }: any) => {
  const center = cell.column.center;
  const maskBehavior = cell.column.maskBehavior;
  const row = cell.row.original;
  const value = row[maskBehavior['value']];
  const format = maskBehavior['format'];
  // console.log(row);

  function renderBlock() {
    return (
      <>
        <ClickableTooltip
          tooltipText={value != null && value !== '' ? value : 'No Data Found'}
          variant='dark'>
          {center ? (
            <TableBodyCellColumnCenter>
              {value != null ? getMaskedValue(value, format) : '-'}
            </TableBodyCellColumnCenter>
          ) : (
            <>{value != null ? getMaskedValue(value, format) : '-'}</>
          )}
        </ClickableTooltip>
      </>
    );
  }
  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {renderBlock()}
    </td>
  );
};

// Utility to strip HTML tags
function stripHtml(html: string) {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}

const HtmlFormattedField = ({ cell, onDoubleClick }: any) => {
  const value = cell.value;
  const center = cell.column.center;
  const safeHtml = DOMPurify.sanitize(value);
  const plainText = stripHtml(safeHtml);

  // function renderBlock() {
  //   const textRef = useRef<HTMLDivElement>(null);
  //   const [isTruncated, setIsTruncated] = useState(false);

  //   useEffect(() => {
  //     const el = textRef.current;
  //     if (el) {
  //       setIsTruncated(el.scrollWidth > el.clientWidth);
  //     }
  //   }, [plainText, cell.column.maxWidth]);

  //   const content = center ? (
  //     <TableBodyCellColumnCenter
  //       ref={textRef}
  //       style={{
  //         maxWidth:
  //           cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
  //             ? `${cell.column.maxWidth}px`
  //             : '225px',
  //         overflow: 'hidden',
  //         textOverflow: 'ellipsis',
  //         whiteSpace: 'nowrap',
  //       }}>
  //       {plainText}
  //     </TableBodyCellColumnCenter>
  //   ) : (
  //     <div
  //       ref={textRef}
  //       style={{
  //         maxWidth:
  //           cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
  //             ? `${cell.column.maxWidth}px`
  //             : '225px',
  //         overflow: 'hidden',
  //         textOverflow: 'ellipsis',
  //         whiteSpace: 'nowrap',
  //       }}>
  //       {plainText}
  //     </div>
  //   );

  //   return isTruncated ? (
  //     <CellTooltipWrapperHover>
  //       {content}
  //       <CellTooltipContent size='md' variant='dark'>
  //         {plainText}
  //       </CellTooltipContent>
  //     </CellTooltipWrapperHover>
  //   ) : (
  //     content
  //   );
  // }
  function renderBlock() {
    const textRef = useRef<HTMLDivElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
      const el = textRef.current;
      if (el) {
        setIsTruncated(el.scrollWidth > el.clientWidth);
      }
    }, [plainText, cell.column.maxWidth]);

    const maxWidth =
      cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
        ? `${cell.column.maxWidth}px`
        : '225px';

    if (isTruncated) {
      return (
        <HoverTooltip
          text={
            plainText
            // <div
            //   style={{
            //     maxHeight: 180,
            //     overflowY: 'auto',
            //     minWidth: 180,
            //     maxWidth: 320,
            //     width: 320,
            //     whiteSpace: 'pre-line',
            //     wordBreak: 'break-all',
            //   }}>
            //   {plainText}
            // </div>
          }
          size='md'
          variant='dark'
          placement='top-center'>
          <div
            style={{
              maxWidth:
                cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
                  ? `${cell.column.maxWidth}px`
                  : '225px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
            {plainText}
          </div>
        </HoverTooltip>
        // <TableCellWithTooltip
        //   value={plainText}
        //   // tooltipContent={<div dangerouslySetInnerHTML={{ __html: safeHtml }} />}
        //   tooltipContent={plainText}
        //   center={center}
        //   maxWidth={maxWidth}
        // />
      );
    }

    // Not truncated: just render the text
    return center ? (
      <TableBodyCellColumnCenter
        ref={textRef}
        style={{
          maxWidth,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
        {plainText}
      </TableBodyCellColumnCenter>
    ) : (
      <div
        ref={textRef}
        style={{
          maxWidth,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
        {plainText}
      </div>
    );
  }

  // function renderBlock() {
  //   const textRef = useRef<HTMLDivElement>(null);
  //   const [isTruncated, setIsTruncated] = useState(false);

  //   useEffect(() => {
  //     const el = textRef.current;
  //     if (el) {
  //       setIsTruncated(el.scrollWidth > el.clientWidth);
  //     }
  //   }, [plainText, cell.column.maxWidth]);

  //   const maxWidth =
  //     cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
  //       ? `${cell.column.maxWidth}px`
  //       : '225px';

  //   const content = center ? (
  //     <TableBodyCellColumnCenter
  //       ref={textRef}
  //       style={{
  //         maxWidth,
  //         overflow: 'hidden',
  //         textOverflow: 'ellipsis',
  //         whiteSpace: 'nowrap',
  //       }}>
  //       {plainText}
  //     </TableBodyCellColumnCenter>
  //   ) : (
  //     <div
  //       ref={textRef}
  //       style={{
  //         maxWidth,
  //         overflow: 'hidden',
  //         textOverflow: 'ellipsis',
  //         whiteSpace: 'nowrap',
  //       }}>
  //       {plainText}
  //     </div>
  //   );

  //   return isTruncated ? (
  //     <CellTooltipWrapperHover>
  //       {content}
  //       <CellTooltipContent
  //         size='md'
  //         variant='dark'
  //         style={{
  //           maxHeight: 180,
  //           overflowY: 'auto',
  //           minWidth: 180,
  //           maxWidth: 320,
  //           width: 320,
  //           whiteSpace: 'pre-line',
  //           wordBreak: 'break-all',
  //           top: '100%',
  //           left: '50%',
  //           transform: 'translateX(-50%)',
  //         }}>
  //         {plainText}
  //       </CellTooltipContent>
  //     </CellTooltipWrapperHover>
  //   ) : (
  //     content
  //   );
  // }
  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {renderBlock()}
    </td>
  );
};

const resolveConditionalDisplay = (
  raw: unknown,
  conditionalValue?: Record<string, string>,
  ifEmptyText = '-'
): string | number => {
  if (raw == null || raw === '') {
    return ifEmptyText;
  }
  if (!conditionalValue) {
    return raw as string | number;
  }
  const key = String(raw);
  return conditionalValue[key] ?? conditionalValue[raw as string] ?? (raw as string | number);
};

const ConditionalField = ({ cell, onDoubleClick }: any) => {
  const center = cell.column.center;
  const conditionalValue = cell.column.conditionalValue;
  const ifEmptyText = cell.column.ifEmptyText ?? '-';
  const value = resolveConditionalDisplay(cell.value, conditionalValue, ifEmptyText);

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {center ? <TableBodyCellColumnCenter>{value}</TableBodyCellColumnCenter> : value}
    </td>
  );
};

const CondtionalDateField = ({ cell, onDoubleClick }: any) => {
  const center = cell.column.center;
  const row = cell.row.original;
  const fields = cell.column.fields;
  const additionalaccessor = row[fields['additionalAccessor']];
  // const value = cell.value ? moment(cell.value).format(DATE_FORMAT) : '-';
  const displayValue = cell.value
    ? moment(cell.value).format(DATE_FORMAT)
    : additionalaccessor
    ? moment(additionalaccessor).format(DATE_FORMAT)
    : '-';
  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {center ? (
        <TableBodyCellColumnCenter>{displayValue}</TableBodyCellColumnCenter>
      ) : (
        displayValue
      )}
    </td>
  );
};

function NumberField({ cell, onDoubleClick }: any) {
  const toUpperCase = cell.column.toUpperCase;
  const showDecimal = cell.column.showDecimal;
  const center = cell.column.center;
  const conditionalValue = cell.column.conditionalValue;
  const fields = cell.column.fields;

  let value = cell.value;
  if (conditionalValue) {
    value = conditionalValue[value] ?? value;
  }
  if (showDecimal) {
    const fixed = cell.column.fixed;
    if (fixed) value = Number(value).toFixed(4);
    // value = convertNumberWithCommas(value, true);
  }

  value = convertNumberWithCommas(value, showDecimal);

  if (fields?.['concatText']) {
    const text = fields['concatText'];
    value = `${value} ${text}`;
    // value = `${convertNumberWithCommas(value)} ${text}`;
  }
  value = setDashAsEmptyValue(value);

  // const displayValue = fields?.['concatText']
  //   ? `${convertNumberWithCommas(value)} ${fields['concatText']}`
  //   : value
  //   ? convertNumberWithCommas(value)
  //   : value;

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      className={clsx(toUpperCase && 'uppercase')}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      <Display>
        <Tag
          variant='default-light'
          title={center ? <TableBodyCellColumnCenter>{value}</TableBodyCellColumnCenter> : value}
        />
      </Display>
    </td>
  );
}

const DateField = ({ cell, onDoubleClick }: any) => {
  const center = cell.column.center;
  const value = cell.value ? moment(cell.value).format(DATE_FORMAT) : '-';

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {center ? <TableBodyCellColumnCenter>{value}</TableBodyCellColumnCenter> : value}
    </td>
  );
};

const DateFieldWithTime = ({ cell, onDoubleClick }: any) => {
  const center = cell.column.center;
  const value = cell.value ? moment(cell.value).format(DATE_FORMAT_WITH_TIME) : '-';

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {center ? <TableBodyCellColumnCenter>{value}</TableBodyCellColumnCenter> : value}
    </td>
  );
};

const TimeField = ({ cell, onDoubleClick }: any) => {
  const center = cell.column.center;
  const value = cell.value ? moment(cell.value).format(TIME_FORMAT) : '-';

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {center ? <TableBodyCellColumnCenter>{value}</TableBodyCellColumnCenter> : value}
    </td>
  );
};

const DefaultBadgeField = ({ cell, onDoubleClick }: any) => {
  let value = cell.value;

  const formatByComma = cell.column.formatByComma;
  const toUpperCase = cell.column.toUpperCase;
  const showDecimal = cell.column.showDecimal;
  const conditionalValue = cell.column.conditionalValue;

  if (conditionalValue) {
    value = conditionalValue[value] ?? value;
  }
  if (showDecimal) {
    value = convertNumberWithCommas(value, true);
    const fixed = cell.column.fixed;
    if (fixed) value = Number(value).toFixed(4);
  }
  if (formatByComma) {
    value = CommaFormatted(value);
  }

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      <Display>
        <Tag className={clsx(toUpperCase && 'uppercase')} variant={'default'} title={value} />
      </Display>
    </td>
  );
};

const InjectBadgeField = ({ cell, onDoubleClick }: any) => {
  let value = cell.value;
  const hasValueInData = cell.column?.data?.find((item: any) => item.value === value)?.label;
  if (hasValueInData) {
    value = hasValueInData;
  }

  const badgeStatus = cell.column.badgeStatus;
  const toUpperCase = cell.column.toUpperCase;
  const conditionalValue = cell.column.conditionalValue;

  if (conditionalValue) {
    value = conditionalValue[value] ?? value;
  }

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      <Display>
        {value ? (
          <Tag
            className={clsx(toUpperCase && 'uppercase')}
            variant={badgeStatus?.[cell.value] || 'info'}
            title={setDashAsEmptyValue(value)}
          />
        ) : (
          setDashAsEmptyValue(value)
        )}
      </Display>
    </td>
  );
};

const BadgeField = ({ cell, onDoubleClick }: any) => {
  let value = cell.value;

  const badgeStatus = cell.column.badgeStatus;
  const toUpperCase = cell.column.toUpperCase;
  const conditionalValue = cell.column.conditionalValue;
  const defaultBadgeStatus = cell.column.defaultBadgeStatus;
  // console.log('cell.column.conditionalValue', cell.column.conditionalValue);

  if (conditionalValue) {
    value = conditionalValue[value] ?? value;
  }
  console.log('value', value, 'defaultbadgestatus', defaultBadgeStatus);

  const getVariant = () => {
    // First check if there's a specific badge status for this value
    if (badgeStatus && badgeStatus[cell.value]) {
      return badgeStatus[cell.value];
    }
    // If no specific status, use defaultBadgeStatus
    if (defaultBadgeStatus) {
      return defaultBadgeStatus;
    }
    // Final fallback to 'info'
    return 'info';
  };
  // console.log(badgeStatus?.[cell.value]);

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      <Display>
        {value ? (
          <Tag
            className={clsx(toUpperCase && 'uppercase')}
            variant={getVariant()}
            // variant={badgeStatus?.[cell.value] || defaultBadgeStatus || 'info'}
            title={setDashAsEmptyValue(value)}
          />
        ) : (
          setDashAsEmptyValue(value)
        )}
      </Display>
    </td>
  );
};

const CurrencyField = ({ cell, onDoubleClick }: any) => {
  const showDecimal = cell.column.showDecimal;
  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      <TableBodyCellColumnCenter>
        {cell.value ? `$${convertNumberWithCommas(cell.value, showDecimal)}` : '-'}
      </TableBodyCellColumnCenter>
    </td>
  );
};
const PercentageField = ({ cell, onDoubleClick }: any) => {
  const center = cell.column.center;
  const value = cell.value?.toFixed(4);

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {center ? (
        <TableBodyCellColumnCenter>{value ? `${value}%` : '-'}</TableBodyCellColumnCenter>
      ) : (
        <TableBodyCellColumn>{value ? `${value}%` : '-'}</TableBodyCellColumn>
      )}
    </td>
  );
};

function CoupleField({ cell }: any) {
  const toUpperCase = cell.column.toUpperCase;
  const fields = cell.column.fields;
  const row = cell.row.original;
  const enableTag = cell.column.enableTag;

  function renderBlock() {
    return (
      <>
        <div className='cellTitle'>{row[fields['title']]}</div>
        <div className='cellSubtitle'>
          {enableTag ? (
            <Tag
              variant={fields['variant'] ? fields['variant'] : 'default'}
              title={
                fields['subtitlePretext']
                  ? `${fields['subtitlePretext']}${String(row[fields['subtitle']] ?? '')}`
                  : `${String(row[fields['subtitle']] ?? '')}`
              }
              color={`${COLORS.Gray}`}
            />
          ) : (
            row[fields['subtitle']]
          )}
        </div>
      </>
    );
  }

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      className={clsx(toUpperCase && 'uppercase')}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      <TableBodyCellColumn>{renderBlock()}</TableBodyCellColumn>
    </td>
  );
}

function CoupleDateRangeField({ cell }: any) {
  const toUpperCase = cell.column.toUpperCase;
  const fields = cell.column.fields;
  const row = cell.row.original;
  const title = row[fields.title];
  const startDate = row[fields.start];
  const endDate = row[fields.end];

  const formatDate = (date: string) => moment(date).format(DATE_FORMAT);

  const renderDates = () => {
    if (startDate && endDate) {
      return `${formatDate(startDate)} - ${formatDate(endDate)}`;
    }
    if (startDate) {
      return formatDate(startDate);
    }
    if (endDate) {
      return formatDate(endDate);
    }
    return null;
  };

  return (
    <td
      id={`${cell.column.id}-${cell.row.index}`}
      className={clsx(toUpperCase && 'uppercase')}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      <TableBodyCellColumn>
        {title && <div className='cellTitle'>{title}</div>}
        {renderDates() && <div className='cellTitle'>{renderDates()}</div>}
      </TableBodyCellColumn>
    </td>
  );
}

function DateRangeCell({ cell, onDoubleClick }: any) {
  const fields = cell.column.fields;
  const row = cell.row.original;

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      <TableBodyCellColumn>
        {`${moment(row[fields['start']]).format(DATE_FORMAT)} - ${moment(row[fields['end']]).format(
          DATE_FORMAT
        )}`}
      </TableBodyCellColumn>
    </td>
  );
}

// function TableCell({ cell, onDoubleClick }: any) {
//   const toUpperCase = cell.column.toUpperCase;
//   const showDecimal = cell.column.showDecimal;
//   const center = cell.column.center;
//   const conditionalValue = cell.column.conditionalValue;
//   const prefix = cell.column.prefix;
//   const ifEmptyText = cell.column.ifEmptyText ?? '-';

//   let value = cell.value;
//   if (conditionalValue) {
//     value = conditionalValue[value] ?? value;
//   }
//   if (showDecimal) {
//     const fixed = cell.column.fixed;
//     if (fixed) value = Number(value).toFixed(4);
//     value = convertNumberWithCommas(value, true);
//   }

//   value = prefix && !_.isEmpty(value) ? `${prefix}${value}` : value;
//   value = setDashAsEmptyValue(value);
//   value = value ? value : ifEmptyText;
//   // console.log(cell?.column?.id, cell.column.maxWidth);
//   function renderBlock() {
//     return (
//       <>
//         <ClickableTooltip
//           tooltipText={value != null && value !== '' ? value : 'No Data Found'}
//           variant='dark'>
//           {/* {center ? (
//             <TableBodyCellColumnCenter>{value != null ? value : '-'}</TableBodyCellColumnCenter>
//           ) : (
//             <>{value != null ? value : '-'}</>
//           )} */}
//           {center ? (
//             <TableBodyCellColumnCenter
//               maxWidth={
//                 cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
//                   ? `${cell.column.maxWidth}px`
//                   : '225px'
//               }>
//               {value}
//             </TableBodyCellColumnCenter>
//           ) : (
//             // <TableBodyCellColumnCenter>
//             //   {" "}
//             //   <div
//             //     style={{
//             //       maxWidth: `${cell.column.maxWidth}px`,
//             //       // maxWidth: "225px",
//             //       // overflow: "hidden",
//             //       // textOverflow: "ellipsis",
//             //     }}
//             //   >
//             //     {" "}
//             //     {value}
//             //   </div>
//             // </TableBodyCellColumnCenter>
//             <div
//               style={{
//                 maxWidth:
//                   cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
//                     ? `${cell.column.maxWidth}px`
//                     : '225px',
//                 // maxWidth: "225px",
//                 overflow: 'hidden',
//                 textOverflow: 'ellipsis',
//               }}>
//               {value}
//             </div>
//           )}
//         </ClickableTooltip>
//       </>
//     );
//   }
//   return (
//     <td
//       id={`${cell?.column?.id}-${cell?.row?.index}`}
//       className={clsx(toUpperCase && 'uppercase')}
//       onDoubleClick={onDoubleClick}
//       {...cell.getCellProps({
//         style: {
//           minWidth: cell.column.minWidth,
//           width: cell.column.width,
//         },
//       })}>
//       {renderBlock()}
//       {/* {center ? (
//         <TableBodyCellColumnCenter
//           maxWidth={
//             cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
//               ? `${cell.column.maxWidth}px`
//               : '225px'
//           }>
//           {value}
//         </TableBodyCellColumnCenter>
//       ) : (
//         <div
//           style={{
//             maxWidth:
//               cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
//                 ? `${cell.column.maxWidth}px`
//                 : '225px',
//             // maxWidth: "225px",
//             overflow: 'hidden',
//             textOverflow: 'ellipsis',
//           }}>
//           {value}
//         </div>
//       )} */}
//       {/* {center ? <TableBodyCellColumnCenter>{value}</TableBodyCellColumnCenter> : value} */}
//     </td>
//   );
// }

function TableCell({ cell, onDoubleClick }: any) {
  const toUpperCase = cell.column.toUpperCase;
  const showDecimal = cell.column.showDecimal;
  const center = cell.column.center;
  const conditionalValue = cell.column.conditionalValue;
  const prefix = cell.column.prefix;
  const ifEmptyText = cell.column.ifEmptyText ?? '-';
  const fixed = cell.column.fixed;
  let value = cell.value;
  if (conditionalValue) {
    value = conditionalValue[value] ?? value;
  }
  // if (showDecimal) {
  //   const fixed = cell.column.fixed;
  //   if (fixed) value = Number(value).toFixed(4);
  //   value = convertNumberWithCommas(value, true);
  // }

  // Handle numbers: apply decimal and comma formatting
  if ((typeof value === 'number' || (!isNaN(Number(value)) && value !== '')) && value !== null) {
    let num = Number(value);
    if (showDecimal && fixed) {
      num = Number(num.toFixed(4));
    }
    value = convertNumberWithCommas(num, showDecimal);
  }
  // console.log('header1', cell.column.Header, 'value11', value);

  value = prefix && !_.isEmpty(value) ? `${prefix}${value}` : value;
  value = setDashAsEmptyValue(value);
  value = value ? value : ifEmptyText;

  // function renderBlock() {
  //   return (
  //     <ClickableTooltip
  //       tooltipText={value != null && value !== '' && isTruncated() ? value : null}
  //       variant='dark'>
  //       {center ? (
  //         <TableBodyCellColumnCenter
  //           ref={contentRef}
  //           maxWidth={
  //             cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
  //               ? `${cell.column.maxWidth}px`
  //               : '225px'
  //           }>
  //           {value}
  //         </TableBodyCellColumnCenter>
  //       ) : (
  //         <div
  //           ref={contentRef}
  //           style={{
  //             maxWidth:
  //               cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
  //                 ? `${cell.column.maxWidth}px`
  //                 : '225px',
  //             overflow: 'hidden',
  //             textOverflow: 'ellipsis',
  //             whiteSpace: 'nowrap',
  //           }}>
  //           {value}
  //         </div>
  //       )}
  //     </ClickableTooltip>
  //   );
  // }

  function renderBlock() {
    const textRef = useRef<HTMLDivElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
      const el = textRef.current;
      if (el) {
        setIsTruncated(el.scrollWidth > el.clientWidth);
      }
    }, [value, cell.column.maxWidth]);

    const content = center ? (
      <TableBodyCellColumnCenter
        ref={textRef}
        style={{
          maxWidth:
            cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
              ? `${cell.column.maxWidth}px`
              : '225px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
        {value}
      </TableBodyCellColumnCenter>
    ) : (
      <div
        ref={textRef}
        style={{
          maxWidth:
            cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
              ? `${cell.column.maxWidth}px`
              : '225px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
        {value}
      </div>
    );

    return isTruncated ? (
      <HoverTooltip
        text={
          value
          // <div
          //   style={{
          //     maxHeight: 180,
          //     overflowY: 'auto',
          //     minWidth: 180,
          //     maxWidth: 320,
          //     width: 320,
          //     whiteSpace: 'pre-line',
          //     wordBreak: 'break-all',
          //   }}>
          //   {plainText}
          // </div>
        }
        size='md'
        variant='dark'
        placement='top-start'>
        <div
          style={{
            maxWidth:
              cell.column.maxWidth && cell.column.maxWidth !== Number.MAX_SAFE_INTEGER
                ? `${cell.column.maxWidth}px`
                : '225px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
          {content}
        </div>
      </HoverTooltip>
    ) : (
      content
    );
  }

  return (
    <td
      id={`${cell?.column?.id}-${cell?.row?.index}`}
      className={clsx(toUpperCase && 'uppercase')}
      onDoubleClick={onDoubleClick}
      {...cell.getCellProps({
        style: {
          minWidth: cell.column.minWidth,
          width: cell.column.width,
        },
      })}>
      {renderBlock()}
    </td>
  );
}
